import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot'
import { Flex, Text, type TextProps } from '@mantine/core'
import React from 'react'

import type { CoreUserAddress } from '@flecto/types'
import { useAddressInline } from '@flecto/utils'

import { Icon } from '../../src'

type TextAddressProps = Omit<TextProps, 'truncate'> & {
  address: CoreUserAddress
  withIcon?: boolean
  withLabel?: boolean
  truncate?: boolean
}

export function TextAddress({
  address,
  withIcon = true,
  withLabel = false,
  truncate = true,
  ...props
}: TextAddressProps) {
  const inline = useAddressInline()

  return (
    <Text {...props}>
      <Flex gap='sm' align='center'>
        {withIcon && <Icon icon={faLocationDot} data-testid='address-icon' />}
        <Text truncate={truncate ? 'end' : undefined}>
          {inline(address, withLabel)}
        </Text>
      </Flex>
    </Text>
  )
}
